import React from 'react';

function EyeIcon({ width = 200, height = 200, ...props }) {
  return (
    <svg width={width} height={height} {...props} viewBox="0 0 200 200">
      <g>
        <path d="M100,37.5 C58.3333333,37.5 22.75,63.4166667 8.33333333,100 C22.75,136.583333 58.3333333,162.5 100,162.5 C141.666667,162.5 177.25,136.583333 191.666667,100 C177.25,63.4166667 141.666667,37.5 100,37.5 L100,37.5 Z M100,141.666667 C77,141.666667 58.3333333,123 58.3333333,100 C58.3333333,77 77,58.3333333 100,58.3333333 C123,58.3333333 141.666667,77 141.666667,100 C141.666667,123 123,141.666667 100,141.666667 L100,141.666667 Z M100,75 C86.1666667,75 75,86.1666667 75,100 C75,113.833333 86.1666667,125 100,125 C113.833333,125 125,113.833333 125,100 C125,86.1666667 113.833333,75 100,75 L100,75 Z" />
      </g>
    </svg>
  );
}

export default EyeIcon;
